// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3AQoT","fileBtn":"File_fileBtn__3oyFk","closeBtn":"File_closeBtn__3DPQX","fileSelected":"File_fileSelected__en2Hl","disabled":"File_disabled__3I7GK"};